import { Component, Input } from '@angular/core';
import { BookingModel } from '../../../../models/booking.model';
import { TrainingCategoryModel } from '../../../../models/training-category.model';
import { getStatus } from '../../../../utils/booking.utils';
import { translateCondition } from '../../../../utils/seminar.utils';
import { getUserFullName } from '../../../../utils/user.utils';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrl: './booking-details.component.scss',
  standalone: false,
})
export class BookingDetailsComponent {
  public isLoading = true;
  public billingAddressCollapsed: boolean = false;
  @Input() booking: BookingModel;
  @Input() bookingSummary: boolean = false;
  @Input() seminarCategory: TrainingCategoryModel;
  @Input() isAdminView: boolean = false;
  constructor() {}

  public getUserFullName = getUserFullName;
  public getStatus = getStatus;

  // toggle collapse participant details for each participant
  public toggleCollapse(index: number): void {
    this.booking.participants[index]['isCollapsed'] =
      !this.booking.participants[index]['isCollapsed'];
  }

  isExpanded(index: number): boolean {
    return !this.booking.participants[index]['isCollapsed'];
  }

  public getCondition(selectedCondition: string): {
    text: string;
    value: number;
  } {
    const condition = this.booking.seminar.conditions.find(
      it => it.type === selectedCondition
    );

    if (!condition) {
      return {
        text: 'Unbekannt',
        value: 0,
      };
    }

    return {
      text: translateCondition(condition.type) + ':',
      value: condition.price,
    };
  }

  getTotalPrice(): number {
    if (this.booking.discountedPrice === undefined) {
      return this.booking.totalPrice;
    } else if (this.booking.discountedPrice < 0) {
      return 0;
    }
    return this.booking.discountedPrice;
  }

  hasOpenQuestions(): boolean {
    return this.booking.participants?.some(
      participant => participant.questions?.length > 0
    );
  }
}
